import { useContext } from 'react';
import { AuthContext } from '../../providers/AuthProvider';
import { CsrfContext } from "../../../../providers/CsrfProvider";
import { performLogout } from "../../../../utils/auth/LogoutHandler";
import sessionTimeoutService from "../../../../event_handlers/SessionTimeoutService";

const useLogout = () => {
    const { csrfToken } = useContext(CsrfContext);
    const { setAuthClaims } = useContext(AuthContext);

    /**
     * Perform logout and redirect to auth page.
     * When called from inactivity timeout, pass navigate to redirect with "logged out for inactivity" state.
     * @param {Function} navigate - React Router navigate function
     * @param {Object} [options] - Optional; use { redirectState: { logoutReason: 'session_expired' } } for inactivity
     */
    return (navigate, options = {}) => {
        const redirectState = options.redirectState;
        performLogout(
            csrfToken,
            setAuthClaims,
            (path, state) => navigate(path, { state }),
            () => sessionTimeoutService.onLogout(),
            redirectState
        );
    };
};

export default useLogout;
